import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { StyledTitle, StyledParagraph } from '../CustomAntdComponents/Typography';
import { StyledButton } from '../CustomAntdComponents/StyledButton';
import GlobeImage from '../../assets/images/globe.svg';
import { useAuthStore } from '../../store/auth/authStore';
import { isEmbedded } from '../../utils/navigation';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 10px;
`;

const GlobeImageWrapper = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: 30px;
`;

const Title = styled(StyledTitle)`
  && {
    margin-bottom: 16px !important;
    font-size: 28px;
    line-height: 1.2;
    color: #111827;
    text-align: center;
  }
`;

const Description = styled(StyledParagraph)`
  && {
    color: #6B7280;
    font-size: 16px;
    margin-bottom: 40px !important;
    max-width: 400px;
    text-align: center;
  }
`;

type Props = {
  open: boolean;
  onClose: () => void;
};

const SaveDetailsModal = ({ open, onClose }: Props) => {
  const { setAuthModal } = useAuthStore();

  const handleCreateAccount = () => {
    if (isEmbedded()) {
      window.parent.postMessage({ type: 'TRIPS_CREATE_ACCOUNT' }, '*');
    }
    onClose();
    if (!isEmbedded()) {
      setAuthModal(true);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={500}
      className="custom-rounded-modal"
    >
      <ModalContent>
        <GlobeImageWrapper src={GlobeImage} alt="Globe" />
        <Title level={2}>Save your details for future booking</Title>
        <Description>
          Don't go through the stress of filling your details manually all the time, save your details by creating an account
        </Description>
        <StyledButton mode="primary" block onClick={handleCreateAccount} style={{ height: '50px', fontSize: '16px', borderRadius: '100px' }}>
          Create an account
        </StyledButton>
      </ModalContent>
    </Modal>
  );
};

export default SaveDetailsModal;
